module.exports = __webpack_public_path__ + "static/img/choose_bg_1.71359334.png";